export const FRONT_URL = import.meta.env.VITE_FRONT_URL || window.FRONT_URL;
export const KRATOS_UI_URL = import.meta.env.VITE_KRATOS_UI_URL || window.KRATOS_UI_URL;
export const USE_KRATOS_API = import.meta.env.VITE_USE_KRATOS_API === 'true' || window.USE_KRATOS_API === 'true';
export const BUILD_DATE = import.meta.env.VITE_BUILD_DATE || window.BUILD_DATE;
export const SENTRY_ENVIRONMENT = import.meta.env.VITE_SENTRY_ENVIRONMENT || window.SENTRY_ENVIRONMENT;
export const SENTRY_DSN = process.env.SENTRY_DSN || null;
export const DISABLE_DSB_IN_DOCUMENT_PROPERTIES =
  import.meta.env.VITE_DISABLE_DSB_IN_DOCUMENT_PROPERTIES === 'true' ||
  window.DISABLE_DSB_IN_DOCUMENT_PROPERTIES === 'true';
// Ускоренный режим (Codex) нужен только в контурах КТС; по умолчанию выключен и скрыт.
export const FAST_MODE_ENABLED = import.meta.env.VITE_ENABLE_FAST_MODE === 'true' || window.ENABLE_FAST_MODE === 'true';
